<template>
  <div>
        <v-row>
            <v-col cols="12">
                <div class="headline">Touren</div>
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="far fa-search"
                                label="Suchen"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="tables.tour.header"
                            :items="tour"
                            :search="search"
                            class="mb-4"
                            no-data-text="Keine Touren vorhanden"
                            :items-per-page="15"
                    >
                      <template v-slot:item.identifier="{ item }">
                        <TourID :tour="item"></TourID>
                      </template>
                      <template v-slot:item.namedCitiesAndDistricts="{ item }">
                        <TourName :tour="item"></TourName>
                      </template>
                      <template v-slot:item.vehicle="{ item }">
                        <Vehicle :vehicleID="item.vehicle"></Vehicle>
                      </template>
                      <template v-slot:item.workload="{ item }">
                        <TourWorkload :tour="item"></TourWorkload>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn v-if="checkAccess(['ROLE_USER', 'ROLE_ADMIN'])" text icon @click="editItem(item)"><v-icon >far fa-edit</v-icon></v-btn>
                        <v-btn text icon @click="downloadPdf(item.id)"><v-icon>far fa-file-pdf</v-icon></v-btn>
                        <v-btn text icon @click="downloadMapPdf(item.id)"><v-icon>far fa-map</v-icon></v-btn>
                        <v-btn text icon small :to="{name: 'duties', params: {id: item.id}}">
                          <v-icon>far fa-clipboard-list</v-icon>
                        </v-btn>
                        <v-btn v-if="checkAccess(['ROLE_USER', 'ROLE_ADMIN']) && item.weight === 0" text icon @click="deleteItem(item)"><v-icon >far fa-trash</v-icon></v-btn>
                      </template>
                    </v-data-table>
                </v-card>
              <v-card-actions>
                <v-btn @click="dialog = true" color="primary" dark v-if="checkAccess(['ROLE_USER', 'ROLE_ADMIN'])">Neue Tour</v-btn>
                <v-btn @click="showOldData = true" v-if="!showOldData && checkAccess(['ROLE_USER', 'ROLE_ADMIN'])">Alle Touren anzeigen</v-btn>
                <v-btn @click="showOldData = false" v-else>Nur kommende Touren anzeigen</v-btn>
              </v-card-actions>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogEdit" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Tour {{ editedItem.identifier }} am {{ editedItem.date}} bearbeiten</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                          <v-flex xs6>
                            <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field v-model="editedItem.maxWeight" label="Maximale Auslastung"></v-text-field>
                          </v-flex>
                        <v-flex xs12>
                          <v-select :items="vehicles" item-value="id" v-model="editedItem.vehicle" label="Fahrzeug">
                            <template slot="item" slot-scope="data">
                              {{ data.item.title }}
                            </template>
                            <template slot="selection" slot-scope="data">
                              {{ data.item.title }}
                            </template>
                          </v-select>
                        </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="dialogEdit = false">Abbrechen</v-btn>
                    <v-btn text color="primary" @click.native="updateTour()">Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogMap" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Karte</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <l-map ref="myMap" style="height: 300px;"></l-map>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="dialogMap = false">Schließen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="800px">
          <v-card>
        <v-card-title>
          <span class="headline">Neue Tour anlegen</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  v-model="newItem.tourTemplate"
                  :items="tourTemplates"
                  label="Tourvorlage"
                  v-on:change="updateTourTemplate"
                >
                  <template slot="selection" slot-scope="data">
                    <v-btn depressed fab small dark :color="'#' + data.item.color">{{ data.item.identifier }}
                    </v-btn>
                    <span class="pr-4">{{ data.item.date }}</span>
                    <template v-for="(city, index) of data.item.namedCities">
                      <span class="pr-4" :key="index">{{ city }}</span>
                    </template>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-btn depressed fab small dark :color="'#' + data.item.color">{{ data.item.identifier }}
                    </v-btn>
                    <span class="pr-4">{{ data.item.date }}</span>
                    <template v-for="(city, index) of data.item.namedCities">
                      <span class="pr-4" :key="index">{{ city }}</span>
                    </template>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-date-picker
                  v-model="newItem.dates"
                  :first-day-of-week="1"
                  locale="de"
                  :events="tourEvents"
                  :min="new Date().toISOString().substr(0, 10)"
                  event-color="red"
                  multiple
                  full-width
                  scrollable>
                </v-date-picker>
              </v-flex>
              <v-flex xs12>
                <v-select :items="vehicles" item-value="id" v-model="newItem.vehicle" label="Fahrzeug">
                  <template slot="item" slot-scope="data">
                    {{ data.item.title }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item.title }}
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  v-model="newItem.name"
                  label="Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="newItem.capacity"
                  label="Maximale Auslastung"
                ></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="close">Abbrechen</v-btn>
          <v-btn text color="primary" @click.native="save">Speichern</v-btn>
        </v-card-actions>
      </v-card>
        </v-dialog>
  </div>
</template>

<script>
import api from '../api/api'
import TourName from './TourName'
import TourID from './TourID'
import TourWorkload from './TourWorkload'
import Vehicle from './partials/_vehicle'
import VehicleSelect from './partials/_vehicleSelect'

const filters = {
  all: items => items,
  new: items => items.filter(item => item.tour === 0)
}

export default {
  name: 'Tour',
  components: {
    VehicleSelect,
    TourWorkload,
    TourID,
    TourName,
    Vehicle
  },
  computed: {
    duties () {
      return filters['new'](this.$store.state.duties.all)
    },
    tour () {
      if (!this.showOldData) {
        return this.$store.state.tour.all.filter(item => {
          let date = new Date(item.dateEn)
          let today = new Date()
          today.setHours(0)
          today.setMinutes(0)
          if (date >= today) {
            return item
          }
        })
      }
      return this.$store.state.tour.all
    },
    tourTemplates () {
      return this.$store.state.tourTemplate.all
    },
    tourEvents () {
      if (this.newItem.tourTemplate.id !== undefined) {
        let tourTemplateIdentifier = this.newItem.tourTemplate.identifier
        let events = []
        this.tour.forEach(function (item) {
          if (item.identifier === tourTemplateIdentifier) {
            let date = item.date.split('.')
            events.push(date[2] + '-' + date[1] + '-' + date[0])
          }
        })
        return events
      }
    },
    profile () {
      if (this.$store.getters.getProfile.data !== undefined) {
        return this.$store.getters.getProfile.data
      }
      return {firstname: '', lastname: '', roles: []}
    },
    vehicles () {
      return this.$store.state.vehicle.all
    }
  },
  methods: {
    updateTourTemplate () {
      this.newItem.capacity = this.newItem.tourTemplate.max_weight
      this.newItem.name = this.newItem.tourTemplate.name
      this.newItem.vehicle = this.newItem.tourTemplate.vehicle
    },
    getCity (id) {
      return this.$store.state.cities.all.find(element => element.id === id)
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialogEdit = true
    },
    deleteItem (item) {
      this.$store.commit('deleteTour', item)
    },
    updateTour () {
      this.$store.commit('updateTour', this.editedItem)
      this.dialogEdit = false
    },
    close () {
      this.dialog = false
      this.newItem = Object.assign({}, this.defaultItem)
    },
    save () {
      this.$store.commit('addTour', this.newItem)
      this.close()
    },
    checkAccess (roles) {
      return roles.some(r => this.profile.roles.includes(r))
    },
    downloadPdf (id) {
      let tour = this.$store.state.tour.all.find(element => element.id === id)
      let filename = 'Tour ' + tour.template + ' - ' + tour.date + ' - Liste.pdf'
      api.downloadTourPdf(id, filename)
    },
    downloadMapPdf (id) {
      let tour = this.$store.state.tour.all.find(element => element.id === id)
      let filename = 'Tour ' + tour.template + ' - ' + tour.date + ' - Karte.pdf'
      api.downloadTourMapPdf(id, filename)
    }
  },
  data: () => ({
    showOldData: false,
    editedItem: {},
    newItem: {
      tourTemplate: {},
      dates: [],
      name: '',
      capacity: 0,
      vehicle: 0
    },
    defaultItem: {
      tourTemplate: {},
      dates: [],
      name: '',
      capacity: 0,
      vehicle: 0
    },
    menu: false,
    dialog: false,
    dialogEdit: false,
    dialogMap: false,
    search: '',
    tables: {
      tour: {
        header: [
          {text: 'Datum', value: 'date', sortable: false},
          {text: 'Kennung', value: 'identifier', sortable: false},
          {text: 'Fahrzeug', value: 'vehicle', sortable: false},
          {text: 'Name', value: 'name', sortable: false},
          {text: 'Auslastung', sortable: false, value: 'workload'},
          {text: '', sortable: false, value: 'action', align: 'right'}
        ]
      }
    }
  })
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";

    .md-table {
        margin-bottom: 1rem;
    }

    .action.md-icon {
        color: $primary-color;
    }

    .city {
        display: inline-block;
        padding-right: 0.75rem;
    }

    .nearlyFull {
        color: orange;
    }

    .full {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tour.vue